import React from 'react';
import {
    Paper, Box, Typography, Button, CircularProgress
} from '@mui/material';
import BookmarkIcon from '@mui/icons-material/Bookmark';
import BookmarkRemoveIcon from '@mui/icons-material/BookmarkRemove';

const BulkActionToolbar = ({ 
    selectedCount, 
    onAction, 
    onClear, 
    isLoading = false,
    actionType = 'track'
}) => {
    if (selectedCount === 0) {
        return null;
    }

    const actionText = actionType === 'track' ? 'Track Selected' : 'Untrack Selected';
    const ActionIcon = actionType === 'track' ? BookmarkIcon : BookmarkRemoveIcon;

    return (
        <Box sx={{ flexShrink: 0 }}>
            <Paper 
                elevation={2} 
                sx={{ 
                    p: 2,
                    mb: 2,
                    bgcolor: 'var(--sm-btn-contained-bg)',
                    color: 'var(--sm-btn-contained-text)'
                }}
            >
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                    <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
                        {selectedCount} GPU{selectedCount !== 1 ? 's' : ''} selected
                    </Typography>
                    <Button
                        variant="contained"
                        onClick={onAction}
                        disabled={isLoading}
                        startIcon={isLoading ? <CircularProgress size={20} color="inherit" /> : <ActionIcon />}
                        sx={{
                            mr: 1,
                            bgcolor: 'var(--sm-btn-contained-text)',
                            color: 'var(--sm-btn-contained-bg)',
                            '&:hover': {
                                bgcolor: 'var(--sm-btn-contained-text)',
                                opacity: 0.9
                            }
                        }}
                    >
                        {actionText} ({selectedCount})
                    </Button>
                    <Button
                        variant="outlined"
                        onClick={onClear}
                        sx={{
                            borderColor: 'var(--sm-btn-contained-text)',
                            color: 'var(--sm-btn-contained-text)',
                            '&:hover': {
                                borderColor: 'var(--sm-btn-contained-text)',
                                bgcolor: 'rgba(128, 128, 128, 0.15)'
                            }
                        }}
                    >
                        Clear Selection
                    </Button>
                </Box>
            </Paper>
        </Box>
    );
};

export default BulkActionToolbar;